import React from 'react';
import { Box, Typography } from '@mui/material';

import { capabilities } from './landingContent';
import { C, FONT, eyebrowSx, h2Sx, hairlineGridSx, iconTileSx, sectionSx, wrapSx } from './landingTokens';

/**
 * "Engine capabilities", laid out like ScheduleOpt's Results section: eyebrow and
 * headline, then one bordered box split into a 3 x 2 grid by hairlines. Each cell
 * has a gradient icon tile beside its title and a short paragraph below, and
 * tints faintly on hover.
 */
const CapabilitySection: React.FC = () => (
  <Box component="section" id="capabilities" sx={sectionSx}>
    <Box sx={wrapSx}>
      <Typography sx={eyebrowSx}>Engine capabilities</Typography>
      <Typography component="h2" sx={{ ...h2Sx, mt: 1.5 }}>
        {capabilities.title}
      </Typography>

      <Box sx={{ ...hairlineGridSx({ xs: 1, sm: 2, md: 3 }), borderRadius: '16px', mt: { xs: 4, md: 5 } }}>
        {capabilities.items.map(item => {
          const Icon = item.icon;
          return (
            <Box
              component="article"
              key={item.title}
              sx={{
                bgcolor: C.bg,
                minWidth: 0,
                p: { xs: 3, md: '30px 30px 32px' },
                transition: 'background-color .25s ease',
                '&:hover': { bgcolor: `color-mix(in srgb, ${C.blue} 4%, #ffffff)` },
              }}
            >
              <Typography
                component="h3"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '14px',
                  fontFamily: FONT,
                  fontWeight: 700,
                  fontSize: 20,
                  lineHeight: 1.25,
                  letterSpacing: '-0.015em',
                  color: C.ink,
                }}
              >
                <Box component="span" sx={iconTileSx(44)}>
                  <Icon aria-hidden="true" sx={{ fontSize: 22 }} />
                </Box>
                {item.title}
              </Typography>
              <Typography sx={{ fontFamily: FONT, fontSize: 15, lineHeight: 1.65, color: C.body, mt: 2 }}>
                {item.description}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  </Box>
);

export default CapabilitySection;
